import axios from 'axios';
import getHeaders from './headers';

const verifyCaptchaEndpoint = `${process.env.VUE_APP_TRANSFER_TRACKING_API_URL}verify-recaptcha/`;

export default {
  verifyCaptcha: (token) => {
    const headers = getHeaders();
    return axios.post(verifyCaptchaEndpoint, { token }, { headers }).then(status => status.data);
  },
};
